import { render, staticRenderFns } from "./BpsUserWidget.vue?vue&type=template&id=0c690c0e&scoped=true&"
import script from "./BpsUserWidget.vue?vue&type=script&lang=ts&"
export * from "./BpsUserWidget.vue?vue&type=script&lang=ts&"
import style0 from "./BpsUserWidget.vue?vue&type=style&index=0&id=0c690c0e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c690c0e",
  null
  
)

export default component.exports